import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAssessment, ISection, IReport, IAction } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
})
export class ActionsComponent implements OnInit {

  roughcheck: IRoughcheck = {
    rref: '',
    title: '',
    image: '',
    image_alt: '',
    category: '',
    riskprofile: '',
    rewardprofile: '',
    show_risk_reward: 1,
    description: '',
    slug: '',
    status: 0,
    status_email: 0,
    feedback: 0,
    sponsor: '',
    website: ''
  };
  assessment: IAssessment = {};
  actions: IAction[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private location: Location,
    private message: MessageService,
    private logger: LoggerService,
    private title: Title
  ) { }

  ngOnInit(): void {
    this.title.setTitle( 'Roughcheck assessment report' );
    this.roughcheck = this.service.getRoughcheck();
    if (! this.roughcheck.rref) {
      this.service.gotoFromUrl('action', this.route.snapshot);
      return;
    }
    this.assessment = this.service.getAssessment();
    this.roughcheck = this.service.getRoughcheck();
    this.service.getHttpActions()
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Populate report
   */
  private handleSuccess(resp: HttpResponse<any>) {
    const actions: IAction[] = resp.body;
    this.actions = actions;
  }

  /**
   * Go to previous
   * If first section go to assessment page
   * else go to previous section
   */
  goPrevious() {
    this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'report']);
  }
}
